import React, { FC } from "react";
import { CardInterfaces } from "./card.types";
import "./card.scss";
import { Grid } from "@mui/material";

export const Card: FC<CardInterfaces> = ({ children, heigth="340px" }) => {
  return (
    <Grid item xs={10} sm={10} md={6} lg={4} xl={3}>
      <div className="gtc-card" style={{height: heigth}}>{children}</div>
    </Grid>
  );
};
